module.exports = __webpack_public_path__ + "static/media/srcwiz.9441baba.png";